import React from "react";
import { useMsal } from "@azure/msal-react";
import { clearUtilitiesSignOut } from "../../shared/auth/localSession";

const LoginButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    clearUtilitiesSignOut();
    instance.loginRedirect({
      scopes: ["user.read"],
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex flex-col items-center text-center">
          <img
            src="/logo.png"
            alt="Xuno"
            className="h-auto w-full max-w-[210px] object-contain"
          />
          <h1 className="mt-5 text-xl font-semibold tracking-[-0.02em] text-slate-900">
            Xuno Utilities
          </h1>
        </div>

        <button
          type="button"
          onClick={handleLogin}
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-md border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition-colors duration-200 hover:border-slate-400 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 active:bg-slate-200"
        >
          <span
            aria-hidden="true"
            className="grid grid-cols-2 gap-[2px] rounded-sm bg-white p-[1px]"
          >
            <span className="h-2.5 w-2.5 bg-[#f25022]" />
            <span className="h-2.5 w-2.5 bg-[#7fba00]" />
            <span className="h-2.5 w-2.5 bg-[#00a4ef]" />
            <span className="h-2.5 w-2.5 bg-[#ffb900]" />
          </span>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
};

export default LoginButton;
